module.exports = __webpack_public_path__ + "static/media/metropolis-regular.f7b5e589.otf";